import apiClient from './apiClient';

/**
 * Embedded assistant. The server applies fresh authorization to every request.
 * Conversation context stays in this browser session; database lookups are read-only.
 */
const aiService = {
  /**
   * @param {{question:string,language:string,history:Array,context:Object}} payload
   * @returns {Promise<{answer:string, answered:'yes'|'partial'|'no',
   *   sources:Array<{id:string,audience:string,title:string,href:string|null,cited:boolean}>,
   *   language:string}>}
   */
  askAssistant: async ({ question, language, history = [], context = {} }) => {
    // Retrieval and authorized database lookups run inside the host request.
    // Keep the client timeout above the assistant's bounded provider budget.
    const response = await apiClient.post(
      '/ai/assistant/ask',
      { question, language, history, context },
      { timeout: 135000 }
    );
    return response.data.data;
  },
  getAssistantSettings: async () => {
    const response = await apiClient.get('/ai/assistant/settings');
    return response.data.data;
  },
  saveAssistantSettings: async ({ policy, expectedRevision }) => {
    const response = await apiClient.put('/ai/assistant/settings', { policy, expectedRevision });
    return response.data.data;
  },
  refreshAssistantKnowledge: async () => {
    const response = await apiClient.post('/ai/assistant/knowledge/refresh', {}, { timeout: 65000 });
    return response.data.data;
  },
};

export default aiService;
